<template>
  <q-dialog
    v-model="_show"
    content-class="nearestStoreDialog"
    position="bottom"
  >
    <q-card class="no-border-radius">
      <q-card-section class="q-py-none">
        <q-banner dense inline-actions class="q-px-none q-py-sm q-my-xs">
          <span class="font-size-14 text-weight-bolder">
            {{ $t('home.nearest.title') }}
          </span>
          <template #action>
            <q-btn
              size="xs"
              unelevated
              round
              flat
              @click="$emit('update:show', false)"
            >
              <q-icon size="16px" name="font:dm-close" />
            </q-btn>
          </template>
        </q-banner>
      </q-card-section>
      <q-card-section class="q-pt-sm q-pb-sm">
        <ChangePosition :adderss="place.address" @showMap="showMap" />
      </q-card-section>
      <q-card-section class="q-pb-sm q-pt-none storeListBox">
        <div v-if="!visible">
          <q-list v-if="options.length > 0">
            <q-item
              v-for="item in options"
              :key="item.url"
              v-ripple
              clickable
              class="q-px-none q-py-md"
              @click="goItemStore(item.url)"
            >
              <!-- :disable="item.status.statusCode !== 200" -->
              <q-item-section avatar class="logo">
                <q-avatar>
                  <img :src="item.logo || logo" />
                </q-avatar>
                <span class="font-size-12 text-primary q-mt-xs">
                  {{ getDistance(item.distance) }}
                </span>
              </q-item-section>
              <q-item-section class="font-size-14 line-height-120">
                <div class="full-width ellipsis text-weight-bolder q-mb-xs">
                  {{ item.storeName }}
                </div>
                <div class="full-width ellipsis q-mb-xs">
                  <q-icon
                    size="16px"
                    class="text-weight-bold q-mr-xs text-theme-gray"
                    name="font:dm-store"
                  />
                  <span class="font-size-12">
                    {{ getService(item.service) }}
                  </span>
                </div>
                <div>
                  <q-icon
                    size="17px"
                    class="text-weight-bold q-mr-xs text-theme-gray"
                    name="font:dm-timeout"
                  />
                  <span
                    v-if="item.status.statusCode === 200"
                    class="font-size-12"
                  >
                    {{ $t('home.open') }}
                  </span>
                  <span v-else class="font-size-12 text-negative">
                    {{ $t('home.closeText') }}
                  </span>
                </div>
              </q-item-section>
              <q-item-section side>
                <q-icon name="font:dm-right" />
              </q-item-section>
            </q-item>
          </q-list>
          <div v-else class="noHasStore text-center q-mb-lg q-mt-md">
            <div class="text-black">
              <span class="text-weight-bold font-size-16">
                0 {{ $t('home.store') }}
              </span>
              <span class="font-size-14"> {{ $t('home.nearYou') }}</span>
            </div>
            <div class="text-theme-gray">
              <span class="font-size-12">
                {{ $t('home.nearest.noStoreMsg') }}
              </span>
            </div>
          </div>
        </div>
        <q-inner-loading :showing="visible">
          <q-spinner color="primary" size="3em" />
        </q-inner-loading>
      </q-card-section>
    </q-card>
  </q-dialog>
</template>

<script>
import { mapState } from 'vuex';
import { getNearestChainStores } from 'src/api/home';
import ChangePosition from './ChangePosition.vue';

const defaultLogo = 'https://static.bakmigm.co.id/menu/buyer-new-logo.png';

export default {
  components: {
    ChangePosition,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    place: {
      type: Object,
      default: () => {},
    },
    delivery: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      visible: true,
      options: [],
      logo: defaultLogo,
    };
  },
  computed: {
    ...mapState({
      nearestStatus: (state) => state.Menu.nearestStatus,
    }),
    _show: {
      get() {
        return this.show;
      },
      set(v) {
        this.$emit('update:show', v);
      },
    },
  },
  watch: {
    show: {
      handler(val) {
        if (val) {
          const params = {
            chainGroupId: this.storeInfo.chainGroupId,
            productStoreId: this.storeInfo.id,
            longitude: this.place.position.lng,
            latitude: this.place.position.lat,
            isShowSelf: this.delivery,
          };
          this.visible = true;
          getNearestChainStores(params)
            .then((res) => {
              const { code, data } = res;
              if (code === 200) {
                // this.options = data.slice(0, 4);
                const { lengthCutUp, nearestStatus, nearestStoreList } = data;
                this.$store.dispatch('Menu/setNearestStatus', nearestStatus);
                this.options = nearestStoreList.slice(0, lengthCutUp);
              }
            })
            .finally(() => {
              this.visible = false;
            });
        }
      },
    },
  },
  methods: {
    showMap() {
      this.$emit('showMap');
      this.$emit('update:show', false);
    },
    goItemStore(url) {
      // TODO: 设置本地地址
      if (this.delivery) {
        this.$q.localStorage.set('place', this.place);
        window.open(`${url}/products-list`, '_self');
      } else {
        this.$q.localStorage.set('place', this.place);
        window.open(url, '_self');
      }
    },
    getDistance(metre) {
      return `${(metre / 1000).toFixed(1)} km`;
    },
    getService(data) {
      const arr = [];
      if (data?.PICK_UP) arr.push('Pick Up');
      if (data?.DINE_IN) arr.push('Dine In');
      if (data?.DELIVERY) arr.push('Delivery');
      return arr.join(' · ');
    },
  },
};
</script>

<style lang="scss">
.nearestStoreDialog {
  .storeListBox {
    min-height: 95px;
  }
}
</style>
